import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Toast as ToastType } from '../../context/toast/toastType';
import Card from '../Card';

type ToastProps = {
    toast: ToastType;
};

const Toast: React.FC<ToastProps> = ({ toast }) => {
    const [ready, setReady] = useState(false);
    const [toastComplete, setToastComplete] = useState(false);

    // need this to trigger width transition
    useEffect(() => {
        setReady(true);
    }, []);

    const handleAnimationEnd = () => {
        setToastComplete(true);

        setTimeout(() => {
            toast.removeToast();
        }, 1000);
    };

    return (
        <Card
            className={clsx('toast', toast.type, {
                'toast-ready': ready,
                'toast-complete': toastComplete,
            })}
        >
            {toast.message}
            <div
                className='border-timer'
                style={{ animationDuration: `${toast.toastDuration / 1000}s` }}
                onAnimationEnd={handleAnimationEnd}
            />
        </Card>
    );
};

export default Toast;
